import { getUserLocale } from '../locale';
import { DISPLAY_USER_LOCALE, SET_TRANSLATION_MESSAGE } from '../constants/constant_saga_types';

const INIT_STATE = {
  locale: '',
  messages: {}
};

export default function translationReducer(state = INIT_STATE, action) {
  switch (action.type) {
    case DISPLAY_USER_LOCALE:
      return {
        ...state,
        locale: getUserLocale(action.user)
      }
    case SET_TRANSLATION_MESSAGE:
      return {
        ...state,
        ...action.payload
      }
    default:
      return state;
  }
}
